import React from "react";

export default function Trap({ data }) {
  const resultDTO = data?.casinoIndividualResultDTO || data;
  const casinoCardResultMaps = resultDTO?.casinoCardResultMaps || [];
  const casinoIndividualResultMaps = resultDTO?.casinoIndividualResultMaps || [];

  const getResultByType = (resultFor) => {
    const resultObj = casinoIndividualResultMaps.find(
      (item) => item.resultFor === resultFor
    );
    return resultObj?.result?.[0] || "";
  };

  const playerACards =
    casinoCardResultMaps.find((item) => item.resultFor === "Player A")?.result || [];
  const playerBCards =
    casinoCardResultMaps.find((item) => item.resultFor === "Player B")?.result || [];

  const winnerInfo = getResultByType("Main");
  const sevenInfo = getResultByType("Seven");
  const pictureCardInfo = getResultByType("Picture Card");

  const winner = winnerInfo.includes("Player A") ? "Player A" : "Player B";

  const matchTime = resultDTO?.createdAt
    ? new Date(resultDTO.createdAt + "Z").toLocaleString()
    : "";

  return (
    <div className="modal-body">
      <div className="casino-result-modal">
        <div className="casino-result-round-id">
          <span>
            <b>Round Id: </b> {resultDTO?.marketId || ""}
          </span>
          <span>
            <b>Match Time: </b> {matchTime}
          </span>
        </div>

        <div className="row mt-2 text-center">
          <div className="col-md-6">
            <h5>Player A ({playerACards.length})</h5>
            <div className="casino-result-cards">
              {winner === "Player A" && (
                <div className="casino-winner-icon">
                  <i className="fas fa-trophy" />
                </div>
              )}
              {playerACards.map((card, index) => (
                <img
                  key={index}
                  src={`https://versionobj.ecoassetsservice.com/v23/static/front/img/cards/${card}.png`}
                  alt={`A-${index}`}
                />
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <h5>Player B ({playerBCards.length})</h5>
            <div className="casino-result-cards">
              {winner === "Player B" && (
                <div className="casino-winner-icon">
                  <i className="fas fa-trophy" />
                </div>
              )}
              {playerBCards.map((card, index) => (
                <img
                  key={index}
                  src={`https://versionobj.ecoassetsservice.com/v23/static/front/img/cards/${card}.png`}
                  alt={`B-${index}`}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="row mt-3 justify-content-center">
          <div className="col-md-6">
            <div className="casino-result-desc">
              <div className="casino-result-desc-item">
                <div>Main</div>
                <div>{winnerInfo}</div>
              </div>
              <div className="casino-result-desc-item">
                <div>Seven</div>
                <div>{sevenInfo}</div>
              </div>
              <div className="casino-result-desc-item">
                <div>Picture Card</div>
                <div>{pictureCardInfo}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
